import React, { Component, PropTypes } from 'react'
import styles from './RewardList.css'
import RewardInfo from './RewardInfo'

class RewardList extends Component {

  render () {
    const { removeReward, rewards } = this.props
    let views = []
    for (let i = 0; i < rewards.length; i++) {
      let divClassName = 'row'
      let reward = rewards[i]
      if (reward.deleted) {
        continue
      }
      // because this view is shared between review / existing and create program
      if (removeReward) {
        divClassName = divClassName + ' bottom20'
      }
      views.push(
        <div className={divClassName}>
          <RewardInfo
            point={reward.point}
            discount={reward.discount}
            discountType={reward.discountType}
            maximumDiscount={reward.maximumDiscount}
            minimumPurchase={reward.minimumPurchase}
            index={i}
            removeReward={removeReward}
            isLastRow={i === rewards.length - 1}
            isFirstRow={i === 0}
          />
        </div>
      )
    }

    return (
      <div>
        <div className='row bottom10'>
          {views.length > 0 &&
            <div style={{paddingLeft: '28px'}} className='col-md-4'>
              REDEEM POINT
            </div>
          }
          {views.length > 0 &&
            <div className='col-md-8'>
              REWARD
            </div>
          }
        </div>
        <div className={`${removeReward ? '' : styles['list-box']}`}>
          {views}
        </div>
      </div>
    )
  }
}

RewardList.propTypes = {
  rewards: PropTypes.array.isRequired,
  removeReward: PropTypes.func
}

export default RewardList



// WEBPACK FOOTER //
// ./app/pages/Customers/Loyalty/Components/RewardList/RewardList.js